<div class="layout-wrapper" [ngClass]="{'p-input-filled': app.inputStyle === 'filled', 'p-ripple-disabled': !app.ripple,
        'layout-static': isStatic(),
        'layout-overlay': isOverlay(),
        'layout-overlay-active': overlayMenuActive && isOverlay(),
        'layout-horizontal': isHorizontal(),
        'layout-static-active': !staticMenuDesktopInactive && isStatic(),
        'layout-mobile-active': staticMenuMobileActive,
        'layout-rtl': app.isRTL,
        'layout-rightpanel-active': rightPanelActive}"   
    [class]="'layout-menu-'+ app.menuTheme+ ' layout-topbar-'+ app.topbarTheme" id="cozmosAppMain">

    <app-topbar></app-topbar>
    <div *ngIf="!(router?.url?.includes('record/view') || router?.url?.includes('search/document-viewer'))" class="menu-wrapper" (click)="onMenuClick($event)" id="menuWrapper">
        <div class="layout-menu-container" >
            <app-menu></app-menu>
        </div>
    </div>
    <div  [ngClass]="!( router?.url?.includes('record/view') || router?.url?.includes('search/document-viewer'))?'layout-main':'layout-main layout-main-full'" >
        <div  [ngClass]="true?'layout-content':'layout-content layout-content-full'" >  
            <router-outlet></router-outlet>      
        </div>
    </div>
    <app-footer ></app-footer>
    <div *ngIf="staticMenuMobileActive" class="layout-mask modal-in"></div>
</div>
